<template>
    <MainLayout>
        <div class="pagetitle">
            <h1>Roles</h1>
            <nav>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/">
                            <span>Dashboard</span>
                        </router-link>
                    </li>

                    <li class="breadcrumb-item active">Roles</li>
                </ol>
            </nav>
        </div>

        <section class="section dashboard">

            <div class="card">

                <div class="card-header py-3">

                    <div class="row">

                        <h3 class="m-0 font-weight-bold text-primary col-md-11">Roles</h3>

                        <div class="col-md-1">
                            <router-link class="btn btn-primary" to="/Roles/Create"
                                v-if="validatePermission('add_roles')">
                                <i class="bi bi-plus-circle"></i>
                            </router-link>
                        </div>

                    </div>

                </div>

                <div class="card-body mt-2">

                    <Atom1Loader v-if="loading" />

                    <table class="table" v-else>
                        <thead>
                            <tr>
                                <th scope="col">Id</th>
                                <th scope="col">Nombre</th>
                                <th scope="col" class="table-buttons"></th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr v-for="role in roles" :key="role.id">
                                <td>{{ role.id }}</td>
                                <td>{{ role.name }}</td>

                                <td class="table-buttons">
                                    <router-link :to="`/Roles/Edit/${role.id}/`" class="btn btn-sm btn-warning"
                                         v-if="validatePermission('edit_roles')"
                                        style="margin-right: 0.5em;">
                                        <i class="bi bi-pencil-fill"></i>
                                    </router-link>

                                    <button class="btn btn-danger btn-sm btnDelete" @click="deleteRole(role.id)"
                                         v-if="validatePermission('delete_roles')">
                                        <i class="bi bi-trash-fill"></i>
                                    </button>
                                </td>

                            </tr>

                        </tbody>
                    </table>

                </div>
            </div>
        </section>
    </MainLayout>
</template>

<script>
import MainLayout from '../../../layouts/MainLayout';
import toastMixin from '../../../mixins/toastMixin';
import accountMixin from '../../../mixins/accountMixin';
import axios from "axios";
import { checkCatch } from "../../../utils";

import Atom1Loader from '@/components/Utils/Loaders/Atom1Loader.vue';

export default {

    mixins: [toastMixin, accountMixin],

    name: 'Roles',

    components: {
        MainLayout, Atom1Loader
    },

    data() {

        return {

            loading: false,
            roles: [],
        };
    },

    async mounted() {

        await this.getRoles();
        // console.log(this.$env.API_BASE_URL)
        // console.log(this.$env.ENV)
    },

    methods: {

        async getRoles() {

            this.loading = true;

            const headers = {

                'Authorization': `Bearer ${this.accountUser.token}`
            };

            await axios.get(`${this.$env.API_BASE_URL}roles/`, { headers })
                .then((response) => {

                    this.roles = response.data;

                    this.loading = false;

                }).catch((error) => {

                    checkCatch(error);
                });

        },

        deleteRole(id) {

            this.$swal({

                title: '¿Desea eliminar el rol?',
                text: 'No podrá revertirlo',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No',
                showCloseButton: true,
                icon: 'warning',
            }).then((result) => {

                if (result.value) {

                    this.loading = true;

                    const headers = {

                        'Authorization': `Bearer ${this.accountUser.token}`
                    };

                    axios.delete(`${this.$env.API_BASE_URL}roles/delete/${id}/`, { headers })
                        .then(() => {

                            let index = this.roles.findIndex(item => item.id === id);

                            if (index !== -1) {

                                this.roles.splice(index, 1); // Elimina 1 elemento en el índice encontrado
                            }

                            this.showNotification({
                                title: 'Éxito',
                                description: 'Rol eliminado con éxito',
                                timeout: 4,
                            });

                            this.loading = false;

                        }).catch((error) => {

                            checkCatch(error);
                        });
                }
            });
        },
    },
};
</script>